export const isArray = arg => Array.isArray(arg);

export const isError = arg => arg instanceof Error;

export const isEvent = arg =>
  !!arg?.nativeEvent && arg.nativeEvent instanceof Event;
